import React from 'react';

import { QEmptyState } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { IncomingCompany } from 'types';

type PrivateRouteProps = {
  children?: React.ReactElement;
  userGroups: IncomingCompany['usergroups'];
  allowedUserGroups: IncomingCompany['usergroups'];
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, userGroups, allowedUserGroups }) => {
  const { t } = useTranslation();
  const isUserNotAllowed = !userGroups?.some((r) => allowedUserGroups.includes(r));

  if (isUserNotAllowed) {
    return (
      <div data-cy="unauthorized-empty-state">
        <QEmptyState title={t('privateRoute.unauthorizedTitle')} subtitle={t('privateRoute.unauthorizedSubtitle')} />
      </div>
    );
  }
  if (children) {
    return <>{children}</>;
  }

  return <Outlet />;
};

export default PrivateRoute;
